
import Component from '../../../assets/scripts/modules/component'
import { getCookie, setCookie } from '../../../assets/scripts/utilities/simple-cookie.js'
import { setConsentCookie } from '../../../assets/scripts/utilities/datalayer.consent.js'

let timeout = 150

export default class NotificationBarComponent extends Component {
  init () {
    this.container = this.element.querySelector('.notification-bar__container')
    this.buttonLink = this.element.querySelector('.link--preferences')
    this.cookiesLink = this.element.querySelector('.notification-bar__text p a')
    this.buttons = this.element.querySelectorAll('.button')
    this.name = this.element.getAttribute('data-name')
    this.timeout = null

    if (!this.container || !this.buttons.length || !this.name) {
      return
    }

    this.focusableElements = [...this.element.querySelectorAll('a[href], button, input, select')]
    this.focusableElements.forEach(element => element.setAttribute('tabindex', -1))

    this.addEventListeners()

    if (!getCookie(`notification-${this.name}-dismissed`)) {
      timeout += 350

      window.clearTimeout(this.timeout)
      this.timeout = window.setTimeout(() => {
        this.showContainer()
      }, timeout)
    }
  }

  addEventListeners () {
    window.addEventListener(`show-${this.name}-notification`, () => this.showContainer())
    this.buttonLink.addEventListener('click', () => this.notificationDismiss())
    this.cookiesLink.addEventListener('click', () => this.notificationDismiss())
    this.buttons.forEach(button => button.addEventListener('click', () => this.hideContainer()))
  }

  showContainer () {
    this.focusableElements.forEach(element => element.removeAttribute('tabindex'))
    window.requestAnimationFrame(() => this.container.classList.add('notification-bar__container--visible'))
  }

  hideContainer () {
    this.focusableElements.forEach(element => element.setAttribute('tabindex', -1))
    setCookie(`notification-${this.name}-dismissed`, true)
    // Enable marketing and analytics cookies.
    setConsentCookie('analytics-cookies', 'yes')
    // If marketing cookie block is enabled, so after clicking 'Accept' -> marketing cookies will be accepted
    const marketingCookies = window?.drupalSettings?.cookieMarketingBlockIsEnabled

    // Marketing cookies are not required for Wetenschappelijkbureau site.
    const currentHost = window.location.hostname
    if (!currentHost.includes('wetenschappelijkbureau') && marketingCookies) {
      setConsentCookie('marketing-cookies', 'yes')
    } else {
      setConsentCookie('marketing-cookies', 'no')
    }
    window.requestAnimationFrame(() => this.container.classList.remove('notification-bar__container--visible'))
  }

  notificationDismiss () {
    setCookie(`notification-${this.name}-dismissed`, true)
  }
}

window.addEventListener('init-load', () => document.querySelectorAll('.notification-bar').forEach(element => {
  element.instance = element.instance || new NotificationBarComponent(element)
}))
